// takes an array of type (T | undefined | null)[] and returns an array of type T[] with all undefined and null values removed
export function flatten<T>(elements: (T | undefined | null)[]): T[] {
  return elements.filter((e): e is T => e !== undefined && e !== null)
}
